import { IGetEquipamentosDropDownUseCase } from "../../../presentation/useCases/read/get_equipamentos_dropdown_use_case";
import { EquipamentosDropDown } from "../../models/equipamentos_dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

//GetEquipamentosDropDownUseCase

export class GetEquipamentosDropDownUseCase implements IGetEquipamentosDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getEquipamentosDropDown(): Promise<EquipamentosDropDown[]> {
    return await this.repository.getEquipamentosDropDown();
  }
}
